// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__RvUYJ","media":"styles_media__iRePh","textFirst":"styles_textFirst__IgnSM","content":"styles_content__XXxtx","avatar":"styles_avatar__95N3I"};